<!-- 头部组件 -->
<template>
  <div class=''>
    <div class="container">
      <img :src="bgImg"
           alt=""
           class="container__bg">
      <div class="content--wrap">
        <div class="content__left--wrap">
          <span class="content__left__title">{{ title }}</span>
          <div class="content__left__content">{{ content }}
          </div>
          <GButton width="158px"
                   height="50px"
                   class="content__left__btn"
                   v-if="btnText"
                   :text="btnText"
                   @click="btnClick"></GButton>
        </div>
        <div class="content__right--wrap">
          <img :src="imgPath"
               alt=""
               class="
               content__right__img">
        </div>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: 'HeadView',
  props: {
    title: String,
    content: String,
    imgPath: String,
    btnText: String
  },

  components: {},
  data () {
    return {
      bgImg: process.env.BASE_URL + 'bg.png'
    }
  },
  computed: {},
  watch: {},
  // 方法集合
  methods: {
    btnClick () {
      this.$emit('btnClick')
    }
  },
  created () {

  },
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
.container {
  height: 537px;
  min-width: 1500px;
  .container__bg {
    width: 100%;
    height: 537px;
  }
  .content--wrap {
    width: 100%;
    position: absolute;
    height: 537px;
    top: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .content__left--wrap {
      min-width: 500px;
      width: 500px;
      flex-direction: column;
      justify-content: center;
      display: flex;
      margin-left: 360px;
      .content__left__title {
        font-size: 42px;
        font-weight: bold;
      }
      .content__left__content {
        margin-top: 16px;
      }
      .content__left__btn {
        margin-top: 40px;
      }
    }
    .content__right--wrap {
      display: flex;
      flex-grow: 1;
      justify-content: right;
      .content__right__img {
        width: 366px;
        margin-right: 360px;
      }
    }
  }
}
</style>
